import React, { useEffect, useRef, useState } from 'react';

export default function Timeline({ content }) {
  const { title, subtitle, events } = content || {};
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, { threshold: 0.15 });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{title || 'Perjalanan Kami'}</h2>
          <p className="text-lg text-gray-600">{subtitle || 'Sejak awal berdiri hingga hari ini'}</p>
        </div>

        <div className="relative">
          {/* Center line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 md:-translate-x-px" style={{ background: 'linear-gradient(180deg, #66E0FF 0%, #00CFFF 50%, #081626 100%)' }} />

          <div className="space-y-12">
            {(events || []).map((event, i) => (
              <div
                key={i}
                className={`relative flex items-start gap-6 md:gap-0 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} ${visible ? 'animate-fadeInUp' : 'opacity-0'}`}
                style={{ animationDelay: `${i * 0.15}s` }}
              >
                {/* Dot */}
                <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full -translate-x-1/2 border-4 border-white shadow z-10" style={{ backgroundColor: '#66E0FF' }} />

                {/* Content */}
                <div className={`ml-10 md:ml-0 md:w-1/2 ${i % 2 === 0 ? 'md:pr-16 md:text-right' : 'md:pl-16'}`}>
                  <span className="inline-block text-white text-xs font-bold px-3 py-1 rounded-full mb-3" style={{ backgroundColor: '#66E0FF' }}>{event.year}</span>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{event.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{event.description}</p>
                </div>

                {/* Spacer for the other side */}
                <div className="hidden md:block md:w-1/2" />
              </div>
            ))}
          </div>
        </div>

        {/* Empty state */}
        {(!events || events.length === 0) && (
          <div className="relative">
<div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 md:-translate-x-px" style={{ background: 'linear-gradient(180deg, #66E0FF 0%, #00CFFF 100%)' }} />
                {[
              { year: '2022', title: 'Awal Berdiri', description: 'Klinnovac didirikan dengan misi menyediakan pembersih ramah lingkungan untuk Indonesia.' },
              { year: '2023', title: 'Riset & Inovasi', description: 'Mengembangkan formula eco-enzyme pertama yang terbukti efektif dan aman.' },
              { year: '2024', title: 'Ekspansi Produk', description: 'Meluncurkan 4 varian produk pembersih untuk kebutuhan rumah tangga dan industri.' },
              { year: '2025', title: 'Bersertifikasi', description: 'Memperoleh sertifikasi BPOM dan standar keamanan lingkungan internasional.' },
              { year: '2026', title: 'Jangkauan Nasional', description: 'Produk tersedia di seluruh Indonesia melalui jaringan ritel dan e-commerce.' },
            ].map((event, i) => (
              <div
                key={i}
                className={`relative flex items-start gap-6 md:gap-0 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} opacity-0`}
              >
                <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full -translate-x-1/2 border-4 border-white shadow z-10" style={{ backgroundColor: 'rgba(0,207,255,0.3)' }} />
                <div className={`ml-10 md:ml-0 md:w-1/2 ${i % 2 === 0 ? 'md:pr-16 md:text-right' : 'md:pl-16'}`}>
                  <span className="inline-block text-xs font-bold px-3 py-1 rounded-full mb-3" style={{ backgroundColor: 'rgba(0,207,255,0.1)', color: '#081626' }}>{event.year}</span>
                  <h3 className="text-lg font-bold text-gray-400 mb-2">{event.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{event.description}</p>
                </div>
                <div className="hidden md:block md:w-1/2" />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}